<template>
  <div>
    <div class="switcher-container px-4">
      <div
        @click="makeCurrent({ name: 'education-videos' })"
        class="main-service-switcher"
        :class="currentLink == 'education-videos' ? 'active' : ''"
      >
        <div class="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#FE5000"
            width="24"
            height="24"
            viewBox="0 0 576 512"
          >
            <path
              d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
            />
          </svg>
        </div>
        <div class="title text-center">
          {{ $t("message.education.videos") }}
        </div>
      </div>
      <div
        @click="makeCurrent({ name: 'education-manuals' })"
        class="main-service-switcher"
        :class="currentLink == 'education-manuals' ? 'active' : ''"
      >
        <div class="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#FE5000"
            width="24"
            height="24"
            viewBox="0 0 448 512"
          >
            <path
              d="M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
            />
          </svg>
        </div>
        <div class="title text-center">
          {{ $t("message.education.manuals") }}
        </div>
      </div>
      <div
        @click="makeCurrent({ name: 'education-examples' })"
        class="main-service-switcher"
        :class="currentLink == 'education-examples' ? 'active' : ''"
      >
        <div class="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#FE5000"
            width="24"
            height="24"
            viewBox="0 0 640 512"
          >
            <path
              d="M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
            />
          </svg>
        </div>
        <div class="title text-center">
          {{ $t("message.education.examples") }}
        </div>
      </div>
      <div
        @click="makeCurrent({ name: 'education-links' })"
        class="main-service-switcher"
        :class="currentLink == 'education-links' ? 'active' : ''"
      >
        <div class="icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#FE5000"
            width="24"
            height="24"
            viewBox="0 0 640 512"
          >
            <path
              d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
            />
          </svg>
        </div>
        <div class="title text-center">
          {{ $t("message.education.links") }}
        </div>
      </div>
    </div>
    <education-videos
      v-if="currentLink == 'education-videos'"
    ></education-videos>
    <education-manuals
      v-if="currentLink == 'education-manuals'"
    ></education-manuals>
    <education-examples
      v-if="currentLink == 'education-examples'"
    ></education-examples>
    <!-- <div class="px-4"><homeBanner /></div> -->
  </div>
</template>
<script>
// import homeBanner from "./../home-banner";
export default {
  name: "EducationIndex",
  // components: { homeBanner },
  props: {
    home: {
      type: Boolean,
      default: false,
    },
    is_guest: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    makeCurrent(data) {
      let { name } = data;
      this.details = data;
      this.currentLink = name;
      if (!this.is_guest) this.$router.push(data);
    },
  },
  mounted() {
    if (
      this.$route.name == "education-videos" ||
      this.$route.name == "education-videos-single"
    ) {
      this.currentLink = "education-videos";
    }
    if (
      this.$route.name == "education-manuals" ||
      this.$route.name == "education-manuals-single"
    ) {
      this.currentLink = "education-manuals";
    }
    if (
      this.$route.name == "education-examples" ||
      this.$route.name == "education-examples-single"
    ) {
      this.currentLink = "education-examples";
    }
  },
  computed: {
    placeholder() {
      switch (this.currentLink) {
        case "business-note":
          return this.$t("message.find_partner.bn_search_keyword_placeholder");
        case "find-partner-info":
          return this.$t("message.find_partner.search_keyword_placeholder");
        case "find-partner-410":
          return this.$t("message.find_partner.search_keyword_placeholder");
        case "comply-advantage-index":
          return this.$t("message.find_partner.ca_search_keyword_placeholder");
      }
    },
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.currentLink = this.$route.name.replace("-single", "");
        // if(this.$route.name=='education-videos'){
        //     this.currentLink = 'education-videos'
        // }
      },
    },
    fuzziness_connector() {
      let el = this.fuzzy_types.find(
        (item) => item.value == this.fuzziness_connector,
      );
      this.search_obj.fuzziness = el;
    },
    search_obj: {
      deep: true,
      handler() {
        this.saveSearchParams();
      },
    },
  },
  data() {
    return {
      details: {
        name: "comply-advantage-index",
        prices: {},
        services: {},
      },
      search: "",
      search_obj: {
        entity: 0,
        fuzziness: {
          value: 100,
          display_text: this.$t("message.comply_advantage.fuzzy_100"),
        },
      },
      fuzziness_connector: 100,
      currentLink: "education-videos",
      show_search_params: false,

      entity_types: [
        {
          display_text: this.$t("message.comply_advantage.entity_type_all"),
          value: 0,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"/></svg>',
        },
        {
          display_text: this.$t("message.comply_advantage.entity_type_person"),
          value: 1,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/></svg>',
        },
        {
          display_text: this.$t("message.comply_advantage.entity_type_company"),
          value: 2,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"/></svg>',
        },
        {
          display_text: this.$t(
            "message.comply_advantage.entity_type_organisation",
          ),
          value: 3,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"/></svg>',
        },
        {
          display_text: this.$t("message.comply_advantage.entity_type_vessel"),
          value: 4,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"/></svg>',
        },
        {
          display_text: this.$t(
            "message.comply_advantage.entity_type_aircraft",
          ),
          value: 5,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"/></svg>',
        },
      ],
      fuzzy_types: [
        {
          display_text: this.$t("message.comply_advantage.fuzzy_exact"),
          value: 0,
        },
        // {display_text: this.$t('message.comply_advantage.fuzzy_0'), value: 0},
        {
          display_text: this.$t("message.comply_advantage.fuzzy_10"),
          value: 10,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_20"),
          value: 20,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_30"),
          value: 30,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_40"),
          value: 40,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_50"),
          value: 50,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_60"),
          value: 60,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_70"),
          value: 70,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_80"),
          value: 80,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_90"),
          value: 90,
        },
        {
          display_text: this.$t("message.comply_advantage.fuzzy_100"),
          value: 100,
        },
      ],
    };
  },
};
</script>
<style scoped>
.switcher-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.main-service-switcher {
  width: 23%;
  padding: 20px;

  /* primary100 */

  background: #ffffff;
  border-radius: 20px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  text-decoration: none !important;
}
.main-service-switcher.active {
  background: var(--color2);
  box-shadow:
    0px 30px 40px rgba(71, 178, 228, 0.5),
    0px 40px 60px rgba(71, 178, 228, 0.1);
}
.main-service-switcher .icon {
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: #f9fafa;
  margin: 0 auto 12px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-service-switcher.active .icon {
  background-color: #fff;
}
.main-service-switcher .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  letter-spacing: 0.25px;
  text-decoration: none !important;
  /* attis/primary */

  color: #04416d;
}
.main-service-switcher.active .title {
  color: #fff;
}
.search-block {
  margin-top: 60px;
  display: flex;
  position: relative;
  gap: 20px;
}
.search-block .icon {
  position: absolute;
  top: 13px;
  left: 40px;
}
.search-block input {
  flex-basis: 100%;
  box-shadow:
    0px 12px 32px rgba(0, 0, 0, 0.04),
    0px 8px 24px rgba(0, 0, 0, 0.04),
    0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.08);
  border-radius: 30px;
  padding: 14px 44px;
  border: 0;
}
.search-block button {
  padding: 14px 40px;
  background: linear-gradient(90deg, var(--color1) 0%, var(--color2) 100%);
  border-radius: 30px;
  border: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* primary100 */

  color: #ffffff;
}
.additional_ca_options fieldset {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 12px;
  gap: 8px;

  /* neutral/50 */

  border: 1px solid #b1b1b1;
  border-radius: 4px;
}
.additional_ca_options fieldset legend {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
  width: auto;
  padding: 0 5px;
}
.additional_ca_options .radio-selector-w-icons {
  display: flex;
  width: 100%;
}
.additional_ca_options .radio-selector-w-icons label {
  width: 16%;
  flex-basis: 16%;
  flex-grow: 0;
  flex-shrink: 0;
  font-size: 10px;
  text-align: center;
  position: relative;
  padding: 15px 0;
  cursor: pointer;
}
.additional_ca_options .radio-selector-w-icons label input {
  position: absolute;
  opacity: 0;
}
.additional_ca_options .radio-selector-w-icons label span {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}
.additional_ca_options
  .radio-selector-w-icons
  label
  input:checked
  + span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border: 2px solid var(--color2);
  border-radius: 8px;
}
datalist {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  writing-mode: vertical-lr;
  width: 100%;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
}
.range-parent {
  display: block;
  width: 100%;
}
.range-comment {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
  margin-top: 10px;
}
.range-parent input {
  width: 100%;
}

[type="range"] {
  --range: calc(var(--max) - var(--min));
  --ratio: calc((var(--val) - var(--min)) / var(--range));
  --sx: calc(0.5 * 1.5em + var(--ratio) * (100% - 1.5em));
  margin: 0;
  padding: 0;
  width: 12.5em;
  height: 1.5em;
  background: transparent;
  font:
    1em/1 arial,
    sans-serif;
}
[type="range"],
[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
[type="range"]::-webkit-slider-runnable-track {
  box-sizing: border-box;
  border: none;
  width: 12.5em;
  height: 0.25em;
  background: #ccc;
  border-radius: 4px;
}
.js [type="range"]::-webkit-slider-runnable-track {
  background: linear-gradient(#cfebf8, #cfebf8) 0 / var(--sx) 100% no-repeat
    #ccc;
}
[type="range"]::-moz-range-track {
  box-sizing: border-box;
  border: none;
  width: 12.5em;
  height: 0.25em;
  background: #ccc;
  border-radius: 4px;
}
[type="range"]::-ms-track {
  box-sizing: border-box;
  border: none;
  width: 12.5em;
  height: 0.25em;
  background: #ccc;
  border-radius: 4px;
}
[type="range"]::-moz-range-progress {
  height: 0.25em;
  background: #cfebf8;
}
[type="range"]::-ms-fill-lower {
  height: 0.25em;
  background: #cfebf8;
}
[type="range"]::-webkit-slider-thumb {
  margin-top: -0.625em;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: #259fe2;
}
[type="range"]::-moz-range-thumb {
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: #259fe2;
}
[type="range"]::-ms-thumb {
  margin-top: 0;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 1.5em;
  border-radius: 50%;
  background: #259fe2;
}
[type="range"]::-ms-tooltip {
  display: none;
}

.additional_ca_options {
  display: flex;
  gap: 20px;
}
.additional_ca_options fieldset {
  flex-basis: 50%;
}
@media (max-width: 768px) {
  .switcher-container {
    flex-direction: column;
    gap: 16px;
    padding: 0;
  }
  .main-service-switcher {
    width: 100%;
    min-width: 0;
    padding: 16px;
    margin: 0;
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
  }
  .main-service-switcher .icon {
    margin: 0 16px 0 0;
  }
  .main-service-switcher .title {
    justify-content: flex-start;
    text-align: left;
    font-size: 16px;
  }
}
</style>
<style>
.additional_ca_options .radio-selector-w-icons label span svg {
  width: 18px;
  height: 18px;
  display: block;
  fill: #b1b1b1;
}
.additional_ca_options .radio-selector-w-icons label input:checked + span svg {
  fill: #259fe2;
}
.togglebutton label .toggle::before {
  background: #b1b1b1;
  border: 0;
  height: 22px;
  width: 44px;
}

.togglebutton label .toggle::before {
  background: #b1b1b1 !important;
  border: 0 !important;
  height: 22px !important;
  width: 44px !important;
}
.togglebutton label .toggle::after {
  width: 18px !important;
  height: 18px !important;
  background-color: #fff !important;
  top: 2px !important;
  left: 2px !important;
}
.togglebutton label input:checked ~ .toggle::before {
  background: linear-gradient(90deg, #b1b1b1  0%, #b1b1b1 100%) !important;
}
.togglebutton label input:checked ~ .toggle::after {
  left: 24px !important;
  transform: unset !important;
}
</style>
